export default __webpack_public_path__ + "static/media/Mark-6-HUD-Pop-Up (Process).58447f1d.jpg";